<template lang="pug">
v-app

  v-dialog(v-model="dialog.pedido", v-if="pedido && dialog.pedido", scrollable, max-width="550")
    v-card.br-10(flat)
      v-card-title.title Pedido {{ pedido.id }}
      v-card-text
        ticketPadrao(v-if="$root.layoutImpressaoNormalSelecionado", :pedido="pedido", color="white")
        ticketNovo(v-if="!$root.layoutImpressaoNormalSelecionado", :pedido="pedido", color="white")
      v-card-actions
        v-spacer
        v-btn(type="button", :disabled="loading", flat, color="gray darken-1", @click.native="dialog.pedido = false; pedido = null;") Fechar

  v-dialog(v-model="dialog.responder", max-width="500", v-if="avaliacao && avaliacao.id && mobile")
    form(@submit.prevent="salvar")
      v-card.br-10.Poppins
        v-card-title.headline.pl-3.pb-0.pt-3.pr-3.Poppins(style="color: rgba(17, 19, 18, 0.64);display: flex;justify-content:   space-between;")
          | Avaliação
          small {{ avaliacao.pedido_id }}
        v-btn.subheading.white--text.Captalize.br-5(color="primary", depressed, :disabled="!avaliacao.pedido_id", @click="visualizarPedido(avaliacao.pedido_id)", style="cursor: pointer;") Ver Pedido
        v-card-text.pl-3.pt-4.pb-2.pr-3
          v-flex.pa-0.infosUsuarioGerenciador
            div(style="width: 100%;")
              v-flex.pa-0
                span.subheading.font-weight-medium {{ avaliacao.usuario ? avaliacao.usuario : "Nome do Usuário"}}
                div.right.itensAvalia
                  v-spacer
                  img(style="max-width: 15px;", :src="require('@/assets/images/star.png')")
                  .right.ml-1.body-1.font-weight-medium(style="padding-top:2px;") {{ $root.formatRating(avaliacao.estrelas) }}
              label.pa-0(style="color: rgba(17, 19, 18, 0.74); padding-left: 12px;" ) {{ avaliacao.data ? $dayjs(avaliacao.data).format('DD/MM/YYYY') : "XX/XX/XXXX" }}
          v-layout.notasDeAvaliacao.mt-2(row, wrap, v-if="avaliacao.nota1 && avaliacao.nota2 && avaliacao.nota3")
            v-flex.md3.dadosAvaliacao.bl(style="min-height: 66px; background-color: #e8e8e87a;")
              v-flex.pa-0(style="text-align: center;")
                img.mr-1(style="max-width: 15px;", :src="require('@/assets/images/star.png')")
                span.subheading.font-weight-medium {{ $root.formatRating(avaliacao.nota1) }}
                .body-1 Produto
            v-flex.md3.dadosAvaliacao(style="min-height: 66px; background-color: #e8e8e87a;")
              v-flex.pa-0(style="text-align: center;")
                img.mr-1(style="max-width: 15px;", :src="require('@/assets/images/star.png')")
                span.subheading.font-weight-medium {{ $root.formatRating(avaliacao.nota2) }}
                .body-1 Entrega
            v-flex.md3.dadosAvaliacao.br(style="min-height: 66px; background-color: #e8e8e87a;")
              v-flex.pa-0(style="text-align: center;")
                img.mr-1(style="max-width: 15px;", :src="require('@/assets/images/star.png')")
                span.subheading.font-weight-medium {{ $root.formatRating(avaliacao.nota3) }}
                .body-1 Tudo certo
          v-layout.mb-3.mt-2(row, wrap)
            v-flex.pb-0
              v-layout(row, wrap)
                v-flex.xs12
                  v-flex.pa-2.areaComentario.xs12(style="min-height:40px; background-color: #e8e8e87a;")
                    span.ml-1(style="overflow-wrap: break-word;",v-if="avaliacao.mensagem != null") {{ avaliacao.mensagem != '' ? avaliacao.mensagem : 'Não comentou' }}
                    span.ml-1(v-if="!avaliacao.mensagem") {{ avaliacao.mensagem != '' ? 'Comentário do Cliente' : '' }}
          span.subheading.font-weight-medium.pt-4 Responda seu cliente!
          v-textarea.mt-3.inputDefault(:disabled="!avaliacao.usuario", label="Digite sua resposta...", color="gray", required, :rules="[rules.required]", type="text", :error-messages="errors.collect('resposta')", data-vv-name="resposta", v-model='avaliacao.resposta', :hide-details="true" autofocus, outline)
        v-card-actions.pl-3.pr-3.pb-4
          v-btn.enviarComentario.br-5(:disabled="!avaliacao.usuario" color="primary", type="submit", @click="salvar()") Responder


  WarningSelect(v-show="!estabelecimentoSelecionado")

  v-container(grid-list-xl, fluid, v-show="estabelecimentoSelecionado")
    v-layout(row, wrap)
      v-flex(lg12, pt-0)
        v-card.pa-3.br-10.cardPadrao
          v-layout(row, wrap)
            v-flex.md10.xs12
              v-text-field.Poppins.icon-green.inputDefault(
                label="Buscar avaliação",
                color="primary",
                height="50px",
                v-model="search",
                clearable,
                outline,
                :hide-details="true"
                prepend-inner-icon="search"
                @input="debouncedSearch"
              )
            v-spacer
            v-flex.md2.xs12
              v-menu.xs12(offset-y, max-width="280px")
                template.xs12(v-slot:activator="{ on, attrs }")
                  v-btn.ma-0.xs12.br-10.right.botaoFiltro.white--text(v-bind="attrs", v-on="on", depressed, color="primary")
                    i.fa.fa-filter.pr-2
                    | Filtros
                v-card.pt-2
                  v-list
                    span.pl-3.font-weight-bold Filtrar por avaliações:
                    v-list-tile(v-for="item in allStatus", :key="item.id" :disabled="!allStatus.length", )
                      v-flex(md12, xs12, pa-0, justify-center, d-flex, style="flex-wrap: wrap; align-items: center;")
                        v-btn.ma-0.xs12.br-5(class="botaoItemFiltro", height="33px", @click="aplicarFiltro(item)", depressed)
                          span.Poppins {{item.nome}}

    v-layout(row, wrap, v-if="list.length").pr-3.pl-3
      v-flex.md9.text-xs-left
        v-tooltip(top, style="display:flex; align-items: center")
          v-btn(icon, slot="activator", @click="getAvaliacoes").pa-0.ma-0.ml-0
            v-icon refresh
          span Atualizar lista de avaliações
      v-flex.md3.text-xs-right(v-if="filtroAplicado")
        v-chip(close, v-model="showFiltroAplicado", color="#E3F0E9") {{filtroAplicado}}
        //- div(style="max-width:100%;width:auto;background-color: #E3F0E9; border-radius: 8px; padding: 0 10px;", v-if="filtroAplicado != null").font-weight-medium
        //-   span {{ 'Filtro aplicado: ' + filtroAplicado != null ? filtroAplicado : ''}}
        //-   v-btn(icon)
        //-     i.fa.fa-times
    v-layout.Poppins(row,v-if="loading")
      v-flex.ma-3.text-xs-center.mt-3
        v-progress-linear(:indeterminate="true").ma-1
    v-layout.Poppins(row, v-if="!list.length && !loading")
      v-flex.ma-3.text-xs-center.mt-3
        .subheading.font-weight-regular(v-if="PERIODO <= 90") Não há nenhuma avaliação nos últimos 90 dias.
        .subheading.font-weight-regular(v-else) Não há nenhuma avaliação.
    v-layout.ma-0(row, wrap, v-if="list.length")
      v-flex.md5.cardGeralAvaliacao.br-10.Poppins
        v-flex.xs12
          v-card.pa-3.cardHistoricoAvaliacao.br-10
            .subheading(style="color: rgba(17, 19, 18, 0.74);") Nota
            .body-1(style="color: rgba(17, 19, 18, 0.50);" v-if="PERIODO <= 90") Últimos 90 dias
            v-flex.md12.pl-0.pb-0
              img(:src="require('@/assets/images/' + $root.getStars(notaAtual)[0] + '.png')")
              img(:src="require('@/assets/images/' + $root.getStars(notaAtual)[1] + '.png')")
              img(:src="require('@/assets/images/' + $root.getStars(notaAtual)[2] + '.png')")
              img(:src="require('@/assets/images/' + $root.getStars(notaAtual)[3] + '.png')")
              img(:src="require('@/assets/images/' + $root.getStars(notaAtual)[4] + '.png')")
              span.notaAvaliacao {{ $root.formatRating(notaAtual) }}
              br
            .body-1.mt-1(style="color: rgba(17, 19, 18, 0.50);") {{ list.length }} {{ list.length === 1 ? 'avaliação' : 'avaliações' }}
        v-flex.Poppins.pb-0(v-for="(avaliacao, avaliacaoIndex) in list", :key="avaliacaoIndex", v-if="list.length")
            v-card.cardAvaliacao.br-10.mb-3
              v-card-text()
                v-layout(row, wrap)
                  v-flex.md1
                    v-avatar(v-if="avaliacao.usuario_imagem && avaliacao.usuario_imagem != ''")
                      img.ma-0(:src="`${urlImagem}/usuario/${avaliacao.usuario_imagem}`", style="width: 100%; margin-right: 10px")
                    v-avatar(v-else)
                      img.ma-0(:src="`https://graph.facebook.com/v2.10/${avaliacao.facebook_id}/picture?type=large`", style="width: 100%; margin-right: 10px", v-if="avaliacao.facebook_id && avaliacao.facebook_id != ''")
                      img.ma-0(src="@/assets/images/user.png", style="width: 100%; margin-right: 10px", v-else)
                  v-flex.md10
                    v-flex.pb-0.pt-0
                      span.subheading.font-weight-medium {{ avaliacao.usuario }}
                      v-btn.white--text.Captalize.br-5(color="primary", depressed, v-if="avaliacao.pedido_id", @click="visualizarPedido(avaliacao.pedido_id)") Ver Pedido
                      div.right.itensAvalia
                        img(style="max-width: 15px;", :src="require('@/assets/images/star.png')")
                        .right.ml-1.body-1.font-weight-medium(style="padding-top:2px;") {{ $root.formatRating(avaliacao.estrelas) }}
                    label(style="color: rgba(17, 19, 18, 0.74); padding-left: 12px;" ) {{ $dayjs(avaliacao.data).format('DD/MM/YYYY') }}
                v-layout.notasDeAvaliacao.pt-4(row, wrap, v-if="avaliacao.nota1 && avaliacao.nota2 && avaliacao.nota3")
                  v-flex.md3.dadosAvaliacao.bl
                    v-flex.pa-0(style="text-align: center;")
                      img.mr-1(style="max-width: 15px;", :src="require('@/assets/images/star.png')")
                      span.subheading.font-weight-medium {{ $root.formatRating(avaliacao.nota1) }}
                      .caption Produto
                  v-flex.md3.dadosAvaliacao
                    v-flex.pa-0(style="text-align: center;")
                      img.mr-1(style="max-width: 15px;", :src="require('@/assets/images/star.png')")
                      span.subheading.font-weight-medium {{ $root.formatRating(avaliacao.nota2) }}
                      .caption Entrega
                  v-flex.md3.dadosAvaliacao.br
                    v-flex.pa-0(style="text-align: center;")
                      img.mr-1(style="max-width: 15px;", :src="require('@/assets/images/star.png')")
                      span.subheading.font-weight-medium {{ $root.formatRating(avaliacao.nota3) }}
                      .caption Tudo certo

                v-layout.mb-2(row, wrap)
                  v-flex.pb-0
                    v-layout(row, wrap)
                      v-flex.xs12
                        v-flex(style="display: flex;flex-direction: row").areaComentario.xs12
                          div(style="width: 75%;")
                            span(style="overflow-wrap: break-word;").ml-1 {{ avaliacao.mensagem != '' ? avaliacao.mensagem : 'Não comentou.' }}
                          div
                            label.right(@click="openDialogResponder(avaliacao)", style="cursor: pointer;", class="accent--text").ml-1 {{ !avaliacao.respondida ? 'Responder ' : '' }}

                v-layout.mb-2(row, wrap, v-if="avaliacao.respondida && estabelecimentoSelecionado")
                  v-flex.pt-1
                    v-layout(row, wrap)
                      v-flex.xs12
                        v-flex.areaComentarioParceiro.xs12
                          span.body-1(style="color: rgba(17, 19, 18, 0.50);") {{ estabelecimentoSelecionado.nome }}
                          span.body-1.ml-1(style="color: rgba(17, 19, 18, 0.50);") - {{ $dayjs(avaliacao.data_resposta).format('DD/MM/YYYY') }}
                          div(style="display: flex; flex-direction: row")
                            div(style="width: 100%; height: fit-content")
                                label {{ '↳ ' + avaliacao.resposta}}
                            div(style="width: 40%; height: fit-content; font-size: 0.9em").right
                                label.right(@click="remover(avaliacao)", style="cursor: pointer;color:#D63232 !important;", v-if="avaliacao.respondida") &nbsp;| Remover
                                label.right(@click="openDialogResponder(avaliacao)", style="cursor: pointer;", class="accent--text").mr-1.ml-2 {{ !avaliacao.respondida ? '' : 'Editar ' }}
            v-divider
      v-flex.md7.xs12.pt-0.pr-0(v-if="!mobile && list.length")
        v-card.gerenciadorAvaliacao.pa-3.br-10
          div(v-if="!avaliacao" style="position: absolute; text-align: center;")
            span.display-2.fadeIn.font-weight-medium.Poppins Clique em <br>
            span.display-2.fadeIn.font-weight-bold.Poppins.primary--text Responder
            span.display-2.fadeIn.font-weight-medium.Poppins  em <br>
            span.display-2.fadeIn.font-weight-medium.Poppins algum comentário
          form(v-if="avaliacao && avaliacao.usuario", @submit.prevent="")
            v-card.formulario.br-10.Poppins
              v-card-title
              .headline.pl-2.pb-0.pt-2.pr-2.Poppins(style="color: rgba(17, 19, 18, 0.64);display: flex;justify-content: space-between;height: 40px;")
                | Avaliação
                small {{ "Pedido: " + avaliacao.pedido_id }}
              v-btn.subheading.white--text.Captalize.br-5(color="primary", depressed, v-if="avaliacao.usuario" :disabled="!avaliacao.pedido_id", @click="visualizarPedido(avaliacao.pedido_id)") Ver Pedido
              v-card-text.pa-2.pt-4
                v-flex.pa-0.infosUsuarioGerenciador
                  v-avatar(v-if="avaliacao.usuario_imagem && avaliacao.usuario_imagem != ''")
                    img.ma-0(:src="`${urlImagem}/usuario/${avaliacao.usuario_imagem}`", style="width: 100%; margin-right: 10px")
                  v-avatar(v-else)
                    img.ma-0(:src="`https://graph.facebook.com/v2.10/${avaliacao.facebook_id}/picture?type=large`", style="width: 100%; margin-right: 10px", v-if="avaliacao.facebook_id && avaliacao.facebook_id != ''")
                    img.ma-0(src="@/assets/images/user.png", style="width: 100%; margin-right: 10px", v-else)
                  div.pl-2(style="min-width: 428px;")
                    v-flex.pa-0
                      span.subheading.font-weight-medium {{ avaliacao && avaliacao.usuario ? avaliacao.usuario : "Nome do Usuário"}}
                      div.right.itensAvalia
                        v-spacer
                        img(style="max-width: 15px;", :src="require('@/assets/images/star.png')")
                        .right.ml-1.body-1.font-weight-medium(style="padding-top:2px;") {{ $root.formatRating(avaliacao.estrelas) }}
                    label.pa-0(style="color: rgba(17, 19, 18, 0.74); padding-left: 12px;" ) {{ avaliacao.data ? $dayjs(avaliacao.data).format('DD/MM/YYYY') : "XX/XX/XXXX" }}
                v-layout.notasDeAvaliacao.mt-2(row, wrap, v-if="avaliacao.nota1 && avaliacao.nota2 && avaliacao.nota3")
                  v-flex.md3.dadosAvaliacao.bl.ml-3
                    v-flex.pa-0(style="text-align: center;")
                      img.mr-1(style="max-width: 15px;", :src="require('@/assets/images/star.png')")
                      span.subheading.font-weight-medium {{ $root.formatRating(avaliacao.nota1) }}
                      .body-1 Produto
                  v-flex.md3.dadosAvaliacao
                    v-flex.pa-0(style="text-align: center;")
                      img.mr-1(style="max-width: 15px;", :src="require('@/assets/images/star.png')")
                      span.subheading.font-weight-medium {{ $root.formatRating(avaliacao.nota2) }}
                      .body-1 Entrega
                  v-flex.md3.dadosAvaliacao.br.mr-3
                    v-flex.pa-0(style="text-align: center;")
                      img.mr-1(style="max-width: 15px;", :src="require('@/assets/images/star.png')")
                      span.subheading.font-weight-medium {{ $root.formatRating(avaliacao.nota3) }}
                      .body-1 Tudo certo
                v-layout.mb-3.mt-2(row, wrap)
                  v-flex.pb-0
                    v-layout(row, wrap)
                      v-flex.xs12
                        v-flex(style="max-height:19vh !important; height: fit-content; min-height: 0.1vh; overflow-y:scroll").areaComentario.xs12
                          span.ml-1(style="overflow-wrap: break-word; display: block;",v-if="avaliacao.mensagem != null") {{ avaliacao.mensagem != '' ? avaliacao.mensagem : 'Não comentou' }}
                          span.ml-1(v-if="!avaliacao.mensagem") {{ avaliacao.mensagem != '' ? 'Comentário do Cliente' : '' }}
                span.subheading.font-weight-medium.pt-4 Responda seu cliente!
                v-textarea.mt-3.inputDefault(:disabled="avaliacao && !avaliacao.usuario", label="Digite sua resposta...", color="gray", required, :rules="[rules.required]", type="text", :error-messages="errors.collect('resposta')", data-vv-name="resposta", v-model='avaliacao.resposta', :hide-details="true" autofocus, outline)
              v-card-actions
                v-btn.enviarComentario.br-5(:disabled="avaliacao && !avaliacao.usuario" color="primary", type="submit", @click="salvar()") Responder
              v-card-actions
                v-btn.enviarComentario.br-5(:disabled="avaliacao && !avaliacao.usuario" color="#ff4b4b", type="submit", @click="avaliacao = null") Deixar pra depois
</template>

<script>

import ticketPadrao from "@/components/TicketPadrao";
import ticketNovo from "@/components/TicketNovo";

import _ from 'lodash';
import BoxChart from '@/components/BoxChart';
import WarningSelect from '@/components/WarningSelect';
import util from '@/util';

export default {
  components: {
    ticketPadrao,
    ticketNovo,
    BoxChart,
    WarningSelect
  },
  $_veeValidate: {
    validator: 'new'
  },
  data() {
    return {
      respondida: null,
      notaAtual: 0,
      search: '',
      allStatus: [
        { id: null, nome: 'Todas' },
        { id: 1, nome: 'Respondidas' },
        { id: 0, nome: 'Não Respondidas' }
      ],
      avaliacoes: [],
      loading: false,
      showFiltroAplicado: false,
      dialog: {
        visualizar: false,
        responder: false,
      },
      pedido: null,
      avaliacao: null,
      mobile: null,
      rules: {
        required: value => !!value || 'Field is required',
      },
      filtroAplicado: null
    }
  },
  computed: {
    list () {
      const vm = this;
      return vm.avaliacoes
    },
    urlImagem(){
      return process.env.VUE_APP_IMAGE_URL;
    },
    estabelecimentoSelecionado(){
      return this.$root.estabelecimentoSelecionado;
    },
    PERIODO(){
      const rc = this.$root.FIREBASE_REMOTE_CONFIG || {};
      const est = this.estabelecimentoSelecionado;
      const localidadeId = est ? est.localidade_id : null;
      return util.getPeriodoAvaliacao(rc.QUANTIDADE_AVALIACOES, localidadeId);
    },
  },
  created () {
    this.debouncedSearch = _.debounce(() => {
      this.getAvaliacoes()
    }, 1000)
    if (process.browser) {
      window.addEventListener("resize", this.checkScreen);
      this.checkScreen();
    }
    window.getApp.$on("CHANGE_ESTABELECIMENTO", this.onChangeEstabelecimento);
  },
  beforeDestroy() {
    window.getApp.$off("CHANGE_ESTABELECIMENTO", this.onChangeEstabelecimento);
  },
  mounted(){
    this.onChangeEstabelecimento();
  },
  watch: {
    showFiltroAplicado(val){
      if(!val) this.limparFiltro();
    },
    '$root.FIREBASE_REMOTE_CONFIG.QUANTIDADE_AVALIACOES'(){
      if(this.estabelecimentoSelecionado && !this.estabelecimentoSelecionado.cardapio_digital)
        this.getAvaliacoes();
    }
  },
  methods: {
    onChangeEstabelecimento(){
      console.log('CHANGE_ESTABELECIMENTO AVALIAÇÕES', this.estabelecimentoSelecionado)
      if(this.estabelecimentoSelecionado && !this.estabelecimentoSelecionado.cardapio_digital)
        this.getAvaliacoes()
      else if(this.estabelecimentoSelecionado && this.estabelecimentoSelecionado.cardapio_digital){
          this.$router.push({ path: '/delivery' });
      }
    },
    limparFiltro() {
      this.filtroAplicado = null
      this.respondida = null
      this.getAvaliacoes()
    },
    aplicarFiltro(item) {
      this.avaliacao = null
      if(item.id == null) return this.limparFiltro()
      this.respondida = item.id

      this.filtroAplicado = item.nome
      this.showFiltroAplicado = true;
      this.getAvaliacoes()
    },
    checkScreen() {
      this.windowWidth = window.innerWidth;
      if (this.windowWidth <= 960) {
        this.mobile = true;
        return;
      }
      this.mobile = false;
      return;
    },
    async getAvaliacoes () {
      const vm = this;
      try {
        if (!vm.estabelecimentoSelecionado) return;
        vm.loading = true;
        this.getNota()

        const response = await vm.$axios.get('/avaliacao', { params: {
          estabelecimento_id: vm.estabelecimentoSelecionado.id,
          data_inicio: vm.$dayjs().subtract(vm.PERIODO, "days").format('YYYY-MM-DD 00:00:00'),
		      data_final: vm.$dayjs().format('YYYY-MM-DD 23:59:59'),
          orderDesc: 'data',
          search: vm.search,
          respondida: vm.respondida,
        }});

        console.log('getAvaliacoes', response.data)

        response.data.map(obj => {
          obj.respondida = obj.resposta === null || (obj.resposta && obj.resposta === '') ? 0 : 1;
          obj.estabelecimento = vm.estabelecimentoSelecionado;
        });

        vm.avaliacoes = response.data;
        vm.loading = false;
      } catch (error) {
        const err = error.response && error.response.data ? error.response.data.error : 'Ocorreu um erro ao buscar as avaliações. Atualize a página!';
        window.getApp.$emit('APP_ALERT', { color: 'red', text: err });
        vm.loading = false;
      }
    },
    async getNota(){
      try {
        const vm = this;
        const semanas = [];
        const data_inicio = vm.$dayjs().subtract(90, 'days');

        const {data: avaliacoes } = await vm.$axios.get('/avaliacao', { params: {
          estabelecimento_id: vm.estabelecimentoSelecionado.id,
          data_inicio: vm.$dayjs().subtract(vm.PERIODO, "days").format('YYYY-MM-DD 00:00:00'),
		      data_final: vm.$dayjs().format('YYYY-MM-DD 23:59:59'),
          orderDesc: 'data',
        }});

        for (let i = 0; i <= 12; i++) {
          const inicio_semana = data_inicio.add(i * 7, 'days');
          const fim_semana = inicio_semana.add(6, 'days');

          semanas.push({
            inicio: inicio_semana,
            fim: fim_semana
          });
        }
        let array = [];
        semanas.forEach(semana => {
          const nota = _.meanBy(_.filter(avaliacoes, a => vm.$dayjs(a.data).isBetween(semana.inicio, semana.fim, null, '[]')), 'estrelas') || 0;
          array.push({
            dia: semana.fim.format('DD/MM/YYYY'),
            nota: nota ? vm.$root.formatRating(nota) : 0,
            category: semana.fim.format('DD/MM/YYYY'),
            value: nota ? vm.$root.formatRating(nota) : 0,
          });
        });

        if (avaliacoes.length > 0) {
          vm.notaAtual = vm.$root.formatRating(_.meanBy(avaliacoes, 'estrelas'));
        } else {
          vm.notaAtual = 0;
        }

        array = _.reject(array, { nota: 0 });
        function comparar_datas(a, b) {
          let d1 = vm.$dayjs(a.dia, "DD/MM/YYYY");
          let d2 = vm.$dayjs(b.dia, "DD/MM/YYYY");
          if (d1.isAfter(d2)) {
            return 1;
          } else if (d1.isBefore(d2)) {
            return -1;
          }
          return 0;
        }
        array.sort(comparar_datas)
        vm.dadosGrafico = _.cloneDeep(array, 'dia');
      } catch (error) {
        const err = error.response && error.response.data ? error.response.data.error : 'Ocorreu um erro ao calcular avaliações. Atualize a página!';
        window.getApp.$emit('APP_ALERT', { color: 'red', text: err });
        vm.loading = false;
      }
    },

    openDialogResponder (avaliacao) {
      const vm = this;
      vm.avaliacao = _.cloneDeep(avaliacao);
      vm.dialog.responder = true;
    },

    async visualizarPedido (pedido_id) {
      const vm = this;
      try {
        vm.loading = true;
        vm.pedido = await vm.$root.getPedido(pedido_id);
        vm.loading = false;
        vm.dialog.pedido = true;
      } catch (error) {
        let err = error.response && error.response.data ? error.response.data.error : 'Ocorreu um erro ao visualizar o pedido. Tente novamente!';
        window.getApp.$emit('APP_ALERT', { color: 'red', text: err });
        vm.loading = false;
      }
    },

    async atualizar (avaliacao){
      const vm = this;
      try {
        const response = await vm.$axios.put('/avaliacao/update', avaliacao);
        window.getApp.$emit('APP_ALERT', { color: 'success', text: "Avaliação salva com sucesso!" });
      } catch (error) {
        const err = error.response && error.response.data ? error.response.data.error : 'Ocorreu um erro ao salvar a avaliação. Tente novamente!';
        window.getApp.$emit('APP_ALERT', { color: 'red', text: err });
      }
    },

    async remover (avaliacao) {
      const vm = this;
      try {
        const res = await vm.$confirm("Deseja realmente remover?<br> Essa ação não poderá ser desfeita!");
        if (!res) return;
        const response = await vm.$axios.put('/avaliacao/remove', avaliacao);
        avaliacao.respondida = 0;
        avaliacao.resposta = null;
        avaliacao.data_resposta = null;
        const index = _.findIndex(vm.avaliacoes, { id: avaliacao.id });
        vm.avaliacoes = _.reject(vm.avaliacoes, { id: avaliacao.id });
        vm.avaliacoes = [...vm.avaliacoes.slice(0, index), avaliacao, ...vm.avaliacoes.slice(index)];
        window.getApp.$emit('APP_ALERT', { color: 'success', text: "Resposta removida com sucesso!" });
      } catch (error) {
        const err = error.response && error.response.data ? error.response.data.error : 'Ocorreu um erro ao remover a resposta. Tente novamente!';
        window.getApp.$emit('APP_ALERT', { color: 'red', text: err });
      }
    },

    async responder (avaliacao) {
      const vm = this;
      try {
        if(!vm.estabelecimentoSelecionado) return
        const obj = _.cloneDeep(avaliacao);
        obj.usuario = obj.usuario;
        obj.estabelecimento = vm.estabelecimentoSelecionado.nome;
        const response = await vm.$axios.put('/avaliacao', obj);
        avaliacao.respondida = 1;
        avaliacao.resposta = response.data.resposta;
        avaliacao.data_resposta = response.data.data_resposta;
        const index = _.findIndex(vm.avaliacoes, { id: avaliacao.id });
        vm.avaliacoes = _.reject(vm.avaliacoes, { id: avaliacao.id });
        vm.avaliacoes = [...vm.avaliacoes.slice(0, index), avaliacao, ...vm.avaliacoes.slice(index)];
        vm.dialog.responder = false;
        vm.avaliacao = null;
        vm.loading = false;
        window.getApp.$emit('APP_ALERT', { color: 'success', text: "Avaliação respondida com sucesso!" });
      } catch (error) {
        const err = error.response && error.response.data ? error.response.data.error : 'Ocorreu um erro ao responder a avaliação. Tente novamente!';
        window.getApp.$emit('APP_ALERT', { color: 'red', text: err });
        vm.loading = false;
      }
    },

    async salvar () {
      const vm = this;
      try {
        vm.loading = true;
        let respostaVazia = !Boolean(vm.avaliacao.resposta && vm.avaliacao.resposta.length)
        if (respostaVazia) throw 'Preencha todos os campos corretamente!';
        vm.responder(vm.avaliacao);
        vm.$validator.reset();
      } catch (error) {
        window.getApp.$emit('APP_ALERT', { color: 'red', text: error });
        vm.loading = false;
      }
    },
  },
}
</script>

<style lang="scss">
  .inputDefault .v-input__control .v-input__slot{
    background-color: #f6f6f6!important;
    border-radius: 10px;
    border: 1px solid rgba(0, 0, 0, .15)!important;
  }

  .inputDefault.v-input.v-input--is-focused .v-input__control .v-input__slot{
    border: 1px solid #1d9a5a !important;
  }
</style>

<style lang="scss" scoped>
.Poppins{
    font-family: "Poppins", "Roboto", "Helvetica" !important;
  }
  .Captalize{
    text-transform: capitalize !important;
  }
  .conteudo {
    min-height: 100px;
    height: 100px;
  }
  .br-5{
      border-radius: 5px !important;
  }
  .br-10{
      border-radius: 10px !important;
  }
  .bl{
    border-radius: 10px 0px 0px 10px;
  }

  .br{
    border-radius: 0px 10px 10px 0px;
  }
  .cardPadrao{
    box-shadow:none !important;
    background-color: transparent;
  }
  .botaoFiltro {
    color: #fff;
    height: 56px;
    width: 100%;
    font-size: 15px;
    font-weight: 700;
    text-transform: capitalize;
  }
  .cardHistoricoAvaliacao{
    border: 1px solid rgba(17, 19, 18, 0.2);
    box-shadow:none !important;
    background-color: transparent;
  }
  .cardAvaliacao{
    box-shadow:none !important;
    background-color: #ececec69;
  }
  .notaAvaliacao{
    font-weight: 700 !important;
    font-size: 42px !important;
    line-height: 25px;
    letter-spacing: normal !important;
    padding-left: 10px;
    color: rgba(17, 19, 18, 0.80);
  }
  .itensAvalia{
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .notasDeAvaliacao{
    border-radius: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .dadosAvaliacao{
    background-color: #e8e8e8;
    display: flex;
    justify-content: center;
    align-items: center;
    max-height: 66px;
  }
  .areaComentario{
    border-radius: 8px;
    border: 1px solid rgba(17, 19, 18, 0.08);
    background: #ececec;
  }
  .areaComentarioParceiro{
    border-radius: 8px;
    border: 1px solid rgba(17, 19, 18, 0.08);
    background: rgba(50, 186, 114, 0.08);
  }
  .cardGeralAvaliacao{
    height: 80vh;
    overflow-y: auto;
    box-shadow:none !important;
    background-color: transparent;
  }
.iconSetaPraCima{
  font-size:12px;
  -moz-transform: translateY(-1px);
  -o-transform: translateY(-1px);
  -webkit-transform: translateY(-1px);
  transform: translateX(3px) translateY(-2px) rotate(45deg);
}
.gerenciadorAvaliacao{
  display: flex;
  justify-content: center;
  align-items: center;
  height: 80vh;
  border: 2px solid rgba(17, 19, 18, 0.2);
  box-shadow:none !important;
  background-color: #f1f1f1;
  overflow: hidden;
}
.formulario{
  background-color: transparent;
  box-shadow:none !important;
  min-width: 500px;
  max-width: 500px;
}
.infosUsuarioGerenciador{
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-items: flex-start;
}
.enviarComentario{
  text-transform: capitalize;
  font-size: 16px;
  width: 100%;
  height: 54px;
  color: #fff;
  box-shadow: none !important;
}
.fadeIn{
  animation: fadeIn 3s linear;
}

@keyframes fadeIn {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
</style>
